import Vue from 'vue'
import Vuex from 'vuex'
import aplicacionesStore from './aplicaciones'
import elementosMapaSigStore from './elementosMapaSig'
import navegacionSigStore from './navegacionSig'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)
export default new Vuex.Store({
  
  modules: {
    aplicaciones: aplicacionesStore,
    elementosMapaSig: elementosMapaSigStore,
    navegacionSig: navegacionSigStore
  }
})
